"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketplaceProductSchema = exports.MarketplaceProductStatusSchema = exports.APosMarketplaceProductSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
exports.APosMarketplaceProductSchema = zod_1.z.object({
    marketplaceId: zod_1.z.string().min(1),
    mp_productId: zod_1.z.string().min(1),
    gtin: zod_1.z.string().optional(),
    brand: zod_1.z.string().optional(),
    mpn: zod_1.z.string().optional(),
    name: zod_1.z.string().min(1).max(300),
    description: zod_1.z.string().max(8000).optional(),
    images: zod_1.z.array(zod_1.z.string()).default([]),
    categoryId: zod_1.z.string().optional(),
    specs: zod_1.z.record(zod_1.z.string(), zod_1.z.any()).default({}),
    offerCount: zod_1.z.number().int().nonnegative().default(0),
    minPrice: zod_1.z.number().nonnegative().optional(),
    maxPrice: zod_1.z.number().nonnegative().optional(),
    avgReviewScore: zod_1.z.number().min(0).max(5).optional(),
    totalReviewCount: zod_1.z.number().int().nonnegative().default(0),
    status: zod_1.z.enum(['active', 'inactive', 'merged', 'deleted']).default('active'),
    mergedInto: zod_1.z.string().optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
// ---------------------------------------------------------------------------
// Phase I — canonical product schema (string timestamps, owner-owned scoping).
// Additive: distinct export name; does NOT touch APosMarketplaceProductSchema.
// ---------------------------------------------------------------------------
exports.MarketplaceProductStatusSchema = zod_1.z.enum([
    'active',
    'inactive',
    'merged',
    'deleted',
]);
/**
 * Canonical marketplace product. OWNER-owned after first approval.
 * PK: marketplaceId  SK: mp_productId  (per-marketplaceId scoping, UNIFIED-MODEL §5.1)
 */
exports.MarketplaceProductSchema = zod_1.z.object({
    marketplaceId: zod_1.z.string(),
    mp_productId: zod_1.z.string(),
    // canonical identifiers for matching
    gtin: zod_1.z.string().optional(),
    brand: zod_1.z.string(),
    mpn: zod_1.z.string().optional(),
    // canonical content (owner-owned after first approval; frozen to later sellers)
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    images: zod_1.z.array(zod_1.z.string()),
    categoryId: zod_1.z.string(),
    specs: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    // aggregates within this marketplace
    offerCount: zod_1.z.number(),
    minPrice: zod_1.z.number(),
    maxPrice: zod_1.z.number(),
    avgReviewScore: zod_1.z.number(),
    totalReviewCount: zod_1.z.number(),
    status: exports.MarketplaceProductStatusSchema,
    mergedInto: zod_1.z.string().optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
    createdBy: zod_1.z.string(),
});
//# sourceMappingURL=marketplace-product.schema.js.map